// extracted by mini-css-extract-plugin
export default {"getOutline":"Home_getOutline__Gbuxm","PageHome":"Home_PageHome__amlGQ","CorrectionTop":"Home_CorrectionTop__vO0Dw","Home":"Home_Home__s8iks","ContentArea":"Home_ContentArea__VDvz3"};